module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".social-sharing-widget-properties">\n        Social Sharing Widget\n    </legend>\n    <div class="social-sharing-widget-properties collapse collapse-target">\n        <div class="style-settings-container zmags-input-control">\n            <legend class="social-legend">Style</legend>\n            <label>\n                <div class="options">\n                    ';
 styles.forEach(function (style) { ;
__p += '\n                        <a href="#" data-style="' +
__e( style.category ) +
'">\n                            <div class="style-sharing-container">\n                                <span class="name">' +
__e( style.name ) +
'</span>\n                                <div class="category ' +
__e( style.category ) +
'"></div>\n                            </div>\n                        </a>\n                    ';
 }); ;
__p += '\n                </div>\n            </label>\n        </div>\n        <div class="share-url-settings-container">\n            <legend class="social-legend">Url</legend>\n            <label class="share-url-container">\n                <span class="share-url-label">\n                    <input type="text" class="share-url full-width" placeholder="Optional Share Url">\n                </span>\n                <span class="help-block">\n                    Optional Share Url, by default it will use the Url where the Experience is shown.\n                </span>\n            </label>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetPropertiesView.tpl
// module id = 2068
// module chunks = 0